export default __webpack_public_path__ + "static/horsebg-c551b38f071a1ca3f962ee73acfbf74d.png";